import { loadStripe, Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Lazily loads and caches a single Stripe.js instance for the given
 * publishable key. Subsequent calls (even with the same key) reuse the
 * cached promise instead of re-injecting the Stripe.js script. Added as part
 * of the PayPal/Braintree -> Stripe subscription billing migration.
 */
export function getStripe(publishableKey: string): Promise<Stripe | null> {
  if (!stripePromise) {
    stripePromise = loadStripe(publishableKey);
  }
  return stripePromise;
}

/**
 * Maps a Stripe.js error object to a user-friendly message string, falling
 * back to a generic message when no usable message is present.
 */
export function mapStripeError(error: any): string {
  if (error && error.message) {
    return error.message;
  }
  return 'Something went wrong while processing your payment. Please try again.';
}
